export const isMonitoringEnabled = () => {
  if (import.meta.env.VITE_DEBUG_MONITORING === 'true') {
    return true;
  }
  if (import.meta.env.VITE_CI === 'true') {
    return false;
  }
  return window.location.hostname && !window.location.hostname.includes('localhost');
};
